<template>
  <div class="common"></div>
</template>

<script>
export default {
  name: "common",
  components: {},
  publicDef: {
    newPath: "http://live.zhibo.xw100.com/",
    // newPath: "http://123.56.69.127:8336/",
    newDomain: window.location.hostname
  },
  loadOptions: {
    options: {
      lock: true,
      text: "加载中。。。",
      spinner: "el-icon-loading",
      background: "rgba(0, 0, 0, 0.7)"
    }
  },
  open(msg, title) {
    this.$alert(msg, title, {
      confirmButtonText: "确定",
      callback: action => {
        this.$message({
          type: "info",
          message: `action: ${action}`
        });
      }
    });
  },
  getCookie: function(name) {
    var arr,
      reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)");
    if ((arr = document.cookie.match(reg))) return arr[2];
    else return null;
  },
  setCookie: function(c_name, value, expiredays) {
    var exdate = new Date();
    exdate.setDate(exdate.getDate() + expiredays);
    document.cookie =
      c_name +
      "=" +
      escape(value) +
      (expiredays == null
        ? ""
        : ";domain=" +
          this.publicDef["newDomain"] +
          ";path=/;expires=" +
          exdate.toGMTString());
  },
  delCookie: function(name) {
    var exp = new Date();
    exp.setTime(exp.getTime() - 1);
    var cval = this.getCookie(name);
    if (cval != null)
      document.cookie = name + "=" + cval + ";expires=" + exp.toGMTString();
  },
  getUrlPara: function(name) {
    //获取url上传的参数
    var r = "";
    if (window.location.href.indexOf("?") != -1) {
      var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
      r = window.location.href.split("?")[1].match(reg);
      if (r != null) return decodeURIComponent(r[2]);
      return "";
    } else {
      return "";
    }
  },
  data() {
    return {
      msg: ""
    };
  }
};
</script>


